module.exports = __webpack_public_path__ + "static/media/region_eu.059a09b5.jpg";